// lazy-load.directive.ts
import { onUnmounted } from 'vue';

export function useLazyImgDirective() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const imgEl = entry.target as HTMLImageElement;
        imgEl.src = imgEl.dataset.src || '';
        observer.unobserve(imgEl);
      }
    });
  });

  return (el: HTMLElement, binding: any) => {
    if (!el || !binding.value) return;
    observer.observe(el);
    onUnmounted(() => {
      observer.disconnect();
    });
  };
}

export default useLazyImgDirective;
